import type { ModelTreeItemTitleProps } from "./model-tree-item-title.type";

import ModelTreeItemIcon from "../model-tree-item-icon";

const ModelTreeItemTitle = ({ item }: ModelTreeItemTitleProps) => {
  const { name } = item.data;

  return (
    <div className="model-tree-item-title">
      <ModelTreeItemIcon item={item} />
      {name}
    </div>
  );
};

export default ModelTreeItemTitle;
